if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.thumbnails = this.querySelectorAll('.product-media-modal__thumbnail');
        this.thumbnailsArray = Array.from(this.thumbnails);
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.counterTotal = this.querySelector('.product-media-modal__counter-total');

        this.thumbnails.forEach((thumb) => {
          thumb.addEventListener('click', (event) => {
            event.stopPropagation();
            this.showMediaById(thumb.dataset.mediaId);
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        // Update active thumbnail state and counter
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.updateActiveThumbnail(mediaId);
        this.updateCounter(mediaId);
      }

      showMediaById(mediaId) {
        // Hide all media
        this.querySelectorAll('.product-media-modal__content [data-media-id]').forEach((el) => {
          el.classList.remove('active');
        });

        // Show selected media
        const activeMedia = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Load deferred media if needed
          const deferredMedia = activeMedia.querySelector('deferred-media');
          if (deferredMedia) deferredMedia.loadContent();
        }

        // Update thumbnail active state and counter
        this.updateActiveThumbnail(mediaId);
        this.updateCounter(mediaId);
      }

      updateCounter(mediaId) {
        const index = this.thumbnailsArray.findIndex((thumb) => thumb.dataset.mediaId === mediaId);
        if (this.counterCurrent && index !== -1) {
          this.counterCurrent.textContent = index + 1;
        }
      }

      updateActiveThumbnail(mediaId) {
        this.thumbnails.forEach((thumb) => {
          thumb.classList.toggle('active', thumb.dataset.mediaId === mediaId);
        });
      }
    }
  );
}
